/* eslint-disable camelcase, prefer-destructuring */
import React from 'react';

const weight = {
  date: 1,
  country: 2,
  street: 3,
  location: 4,
  rl: 5,
  qd: 6,
  rw: 7,
  SRT: 8,
  line: 9,
  material_type: 10,
  latitude: 11,
  longitude: 12,
  position: 13,
  grit_beads: 14,
  air_humidity: 15,
  air_temperature: 16,
};

export function sortAttributes(arr) {
  return arr.sort((a, b) => {
    if (!weight[a.item]) {
      return 100 - weight[b.item];
    }
    if (!weight[b.item]) {
      return weight[a.item] - 100;
    }

    return weight[a.item] - weight[b.item];
  });
}

export function splitCoordinates(element) {
  if (element.coordinates) {
    const coords = element.coordinates;
    const newElement = Object.assign({}, element);
    delete newElement.coordinates;
    newElement.latitude = coords[0];
    newElement.longitude = coords[1];
    return newElement;
  }
  return element;
}

export function isEquivalent(a, b) {
  const aProps = Object.getOwnPropertyNames(a);
  const bProps = Object.getOwnPropertyNames(b);

  if (aProps.length !== bProps.length) {
    return false;
  }

  for (let i = 0; i < aProps.length; i++) {
    const propName = aProps[i];
    if (a[propName] !== b[propName]) {
      return false;
    }
  }

  return true;
}

export function showUnits(type) {
  switch (type) {
    case 'air_humidity':
      return ' %';
    case 'air_temperature':
      return ' C';
    case 'rl':
    case 'rw':
    case 'qd':
      return <span>&nbsp;(mcd * lx<sup>-1</sup> * m<sup>-2</sup>)</span>; //eslint-disable-line
    default:
      return '';
  }
}



// WEBPACK FOOTER //
// ./src/services/attributesServices.js